import { gql } from "@apollo/client";

import { OrderDetailType } from "../../../../../graphql/types/OrderDetailType";
import { ORDER_DETAIL_FIELDS } from "../../../../delivery/parcels/graphql/queries/getOrderDetailForCentral";

/**
 * 历史包裹详情（已归档订单）。
 *
 * 字段片段与 getOrderDetailForCentral 共用，返回结构完全一致——详情弹窗组件同一个，
 * 只是主查询换成本接口。
 *
 * 归档订单的行为差异（后端刻意如此）：exceptionSubReasons 恒为空（不读 exception_order），
 * 且不返回任何可编辑性标记（canEditAddressLocation 等恒为 false/null）。
 */
export const GET_ORDER_DETAIL_FOR_HISTORY = gql`
    query GetOrderDetailForHistory($orderId: Long!) {
        getOrderDetailForHistory(orderId: $orderId) {
            ${ORDER_DETAIL_FIELDS}
        }
    }
`;

export interface HistoryOrderDetailResponse {
    getOrderDetailForHistory: OrderDetailType;
}
